<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>{{ title }}</v-card-title>
          <v-card-text>
            <v-row>
              <v-col v-for="(v, k) in seriesData" :key="k" :cols="12 / seriesData.length">
                {{ v.name }}
                <ApexCharts
                  type="donut"
                  :options="v.options"
                  :series="v.series"
                  width="100%"
                  @dataPointSelection="selectedSegment"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ApexCharts from 'vue-apexcharts';

export default {
  name: 'ChartGroup',
  components: {
    ApexCharts,
  },
  props: {
    tableData: { type: Object, default: () => ({}) },
    optionData: { type: Object, default: () => ({}) },
    title: { type: String, default: '' },
    id: { type: String, default: '' },
    chartData: { type: Object, default: () => ({}) },
    source: { type: Array, default: () => [] },
  },
  data() {
    return {
      defaultOptions: {
        labels: ['AC-L', 'AC-M', 'AC-H', 'Clean'],
        colors: ['#20d1db', '#e1ff00', '#ff1c1c', '#a1ff00'],
        tooltip: {
          enabled: false,
        },
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  show: true,
                  color: 'black',
                },
                value: {
                  fontSize: '0.9rem',
                },
                total: {
                  show: true,
                  fontSize: '0.9rem',
                },
              },
            },
          },
        },
        result: [],

        legend: {
          show: true,
          formatter(val) {
            if (val.length > 20) {
              return `${val.slice(0, 6)}...`;
            }
            return val;
          },
        },
      },
    };
  },

  computed: {
    seriesData() {
      // reset results on computing series data
      this.resetResults();

      let i = 0;
      return this.source.map((x) => ({
        name: x.name,
        series: x.series,
        options: {
          ...this.defaultOptions,
          labels: x.labels,
          colors: x.colors,
          // eslint-disable-next-line no-plusplus
          chartNo: i++,
        },
      }));
    },
    sourceLength() {
      return Array.isArray(this.source) ? this.source.length : 0;
    },
  },

  created() {
    function HSLToRGB(h, s, l) {
      s /= 100;
      l /= 100;
      const c = (1 - Math.abs(2 * l - 1)) * s;
      const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
      const m = l - c / 2;
      let r = 0;
      let g = 0;
      let b = 0;

      if (h >= 0 && h < 60) {
        r = c;
        g = x;
        b = 0;
      } else if (h >= 60 && h < 120) {
        r = x;
        g = c;
        b = 0;
      } else if (h >= 120 && h < 180) {
        r = 0;
        g = c;
        b = x;
      } else if (h >= 180 && h < 240) {
        r = 0;
        g = x;
        b = c;
      } else if (h >= 240 && h < 300) {
        r = x;
        g = 0;
        b = c;
      } else if (h >= 300 && h < 360) {
        r = c;
        g = 0;
        b = x;
      }
      r = Math.round((r + m) * 255);
      g = Math.round((g + m) * 255);
      b = Math.round((b + m) * 255);

      return `rgb(${r},${g},${b})`;
    }

    function generateHslaColors(saturation, lightness, alpha, amount) {
      const colors = [];
      const huedelta = Math.trunc(360 / amount);

      for (let i = 0; i < amount; i++) {
        const hue = i * huedelta;
        colors.push(HSLToRGB(hue, saturation, lightness));
      }

      return colors;
    }
    this.colors = generateHslaColors(50, 50, 1.0, 50);
  },
  methods: {
    resetResults() {
      this.result = new Array(this.sourceLength).fill(-1);
    },

    update() {
      this.options = {
        ...this.options,
        ...{
          labels: this.optionData[this.selectedFilter].options,
          colors: this.colors.slice(0, this.optionData[this.selectedFilter].options.length),
        },
      };
    },

    deSelectSegment() {
      const clickedElement = document.querySelectorAll('[data\\:pieClicked=true]');
      if (clickedElement.length > 0 && clickedElement.length === 1) {
        clickedElement[0].dispatchEvent(new Event('click'));
        clickedElement[0].setAttribute('selected', 'false');
        clickedElement[0].removeAttribute('filter');
      } else if (clickedElement.length > 0) {
        for (let index = 0; index < clickedElement.length; index++) {
          const element = clickedElement[index];
          element.dispatchEvent(new Event('click'));
          element[0].setAttribute('selected', 'false');
          element[0].removeAttribute('filter');
        }
      }
    },

    selectedSegment(e, chartContext, config) {
      this.deSelectSegment();
      this.result[config.w.config.chartNo] = config.dataPointIndex;
      const clickInfo = {
        // eslint-disable-next-line eqeqeq
        chart: config.w.config.chartNo == 0 ? 'summary' : 'detail',
        dataPoint: config.dataPointIndex,
      };
      this.$emit('change', this.id, clickInfo);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less"></style>
